import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { IMeeting } from '../../../../../types';
import { useEffect, useState } from 'react';

ChartJS.register(ArcElement, Tooltip, Legend);

interface IStatsProps {
  meeting: IMeeting;
}

const Stats = ({ meeting }: IStatsProps) => {
  const [reponse, setResponse] = useState<number>(0);
  const [noReponse, setNoResponse] = useState<number>(0);

  useEffect(() => {
    setResponse(meeting.members.filter((m) => m.response).length);
    setNoResponse(meeting.members.filter((m) => !m.response).length);
  }, [meeting]);

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between">
        <Col>Stats</Col>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm={{ span: 6, offset: 3 }}>
            <Doughnut
              data={{
                labels: ['Response', 'No response'],
                datasets: [
                  {
                    label: 'Members',
                    data: [reponse, noReponse],
                    backgroundColor: ['rgb(240, 135, 0)', 'rgb(0, 64, 128)'],
                    hoverOffset: 4,
                  },
                ],
              }}
              options={{
                circumference: 180,
                rotation: -90,
                plugins: { legend: { display: false } },
                maintainAspectRatio: false,
              }}
              height={100}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Stats;
